import { Component, input } from '@angular/core';
import { VKratosUiImageWidget } from '../types';

/**
 * Renders an `img` UI node of a Kratos flow — in practice the TOTP QR code
 * of the settings flow. The white padding keeps the code scannable on the
 * app's dark surfaces.
 */
@Component({
  selector: 'v-kratos-image',
  template: `
    @let attrs = widget().imageAttributes;

    <img
      class="rounded-xl bg-white p-2"
      [src]="attrs.src"
      [width]="attrs.width"
      [height]="attrs.height"
      [alt]="widget().label?.text ?? ''" />
  `,
})
export class VKratosImageComponent {
  widget = input.required<VKratosUiImageWidget>();
}
